<div class="error-message text-center">
  @for (error of errors; track error) {
    <div>
      @if (!!error.validation) {
        <span>{{ error.validation }}</span>
      }
      @if (!!error.payment) {
        <span class="stripe-error" [ngbTooltip]="error.payment">Show details</span>
      }
    </div>
  }
</div>
